import { KeyValue } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Banner, UserProfile } from 'src/app/models';
import { BannerCategory, BannerList, BannerRecord } from 'src/app/models/banner.interface';
import { HttpService, TokenService, ScreenSizeService } from 'src/app/services';
import { environment as env } from 'src/environments/environment';
// import Swiper core and required components
import SwiperCore, { Autoplay } from 'swiper';
import { Subscription } from 'rxjs';
// install Swiper components
SwiperCore.use([Autoplay]);

@Component({
  selector: 'cm-home-swiper',
  templateUrl: './home-swiper.component.html',
  styleUrls: ['./home-swiper.component.css']
})
export class HomeSwiperComponent implements OnInit {
  @Input() banners: Banner[];
  protected language: string | null = 'en-US';
  protected bannerCategoryId: number = 1;
  protected bannerCategory: BannerCategory | null = null;
  protected bannerList: BannerList | null = null;
  protected userProfile: UserProfile | null = null;
  screenWidth: number;
  private screenWidthSubscription$: Subscription | null;

  constructor(
    private token: TokenService,
    private translate: TranslateService,
    private http: HttpService,
    private screenSizeService: ScreenSizeService,
  ) {
    this.banners = [];
    this.screenWidth = 0;
    this.screenWidthSubscription$ = null;
  }

  async ngOnInit() {
    this.language = this.token.getLocalToken(env.TokenKeys.LanguageToken);

    if (!this.language) {
      this.language = "en-US"
    }

    this.screenWidthSubscription$ = this.screenSizeService.getScreenWidth().subscribe(width => {
      this.screenWidth = width;
    });

    this.translate.onLangChange.subscribe((value: any) => {
      this.language = value.lang;
      this.getBannerList();
    });

    await this.getBannerCategory();
    await this.getBannerList();
  }

  protected getBannerCategory() {
    return new Promise(async (resolve) => {
      const payload: any = {
        CurrentCulture: this.language,
        // AcctUserId: null,
        // UserRoleId: 0,
        // LoggedInAcctUserId: null,
        IpAddress: this.userProfile?.IpAddress,
        // UserAgent: null,
        // Country: null,
        Id: this.bannerCategoryId,
      };

      this.http.post('banner', 'getBannerCategory', payload)
        .subscribe((resp: BannerCategory) => {
          if (resp && resp.Code == 1) {
            this.bannerCategory = resp;
            resolve(true);
          } else {
            resolve(false);
          }
        });

    });
  }

  protected getBannerList() {
    return new Promise(async (resolve) => {
      const payload: any = {
        CurrentCulture: this.language,
        // AcctUserId: null,
        // UserRoleId: 0,
        // LoggedInAcctUserId: null,
        IpAddress: this.userProfile?.IpAddress,
        // UserAgent: null,
        // Country: null,
        // Search: "",
        // PageNumber: 1,
        // PageSize: 9999,
        // SortBy: 1,
        // SortDirection: 0,
        CategoryId: this.bannerCategoryId,
      };

      this.http.post('banner', 'getBannerList', payload)
        .subscribe((resp: BannerList) => {
          if (resp && resp.Code == 1) {
            this.bannerList = resp;
            const languageFolderName = this.getCapitalUnderscoreLanguageCode(this.language ?? 'en-US');

            if (this.bannerList.Records)
              this.bannerList.Records.forEach(banner => {
                let imageSource = this.getBannerImageSource(banner);
                let mobileImageSource = this.getBannerImageSource(banner, true);

                banner.ImageSource = `${env.AdminAPIURL}/uploads/banner/${languageFolderName}/${this.bannerCategory?.Model.FolderName}/${imageSource}`;
                banner.MobileImageSource = `${env.AdminAPIURL}/uploads/banner/${languageFolderName}/${this.bannerCategory?.Model.FolderName}/${mobileImageSource}`;
              });

            resolve(true);
          } else {
            resolve(false);
          }
        });
    });
  }

  private getCapitalUnderscoreLanguageCode(locale: string): string {
    return locale.split('-').map(part => part.toUpperCase()).join('_');
  }

  private getBannerImageSource(record: BannerRecord, isMobile: boolean = false): string {
    let imageSource = record.Img_EN_US;

    if (this.language == 'en-US') {
      imageSource = isMobile ? record.Img_Mobile_EN_US : record.Img_EN_US;   
    } 
    else if (this.language == 'id-ID') {
      imageSource = isMobile ? record.Img_Mobile_ID_ID : record.Img_ID_ID;
    } 
    else if (this.language == 'jp-JP') {
      imageSource = isMobile ? record.Img_Mobile_JP_JP : record.Img_JP_JP;
    } 
    else if (this.language == 'ko-KO') {
      imageSource = isMobile ? record.Img_Mobile_KO_KO : record.Img_KO_KO;
    } 
    else if (this.language == 'th-TH') {
      imageSource = isMobile ? record.Img_Mobile_TH_TH : record.Img_TH_TH;
    }
    else if (this.language == 'tw-TW') {
      imageSource = isMobile ? record.Img_Mobile_TW_TW : record.Img_TW_TW;
    }
    else if (this.language == 'vi-VN') {
      imageSource = isMobile ? record.Img_Mobile_VI_VN : record.Img_VI_VN;
    }
    else if (this.language == 'zh-CN') {
      imageSource = isMobile ? record.Img_Mobile_ZH_CN : record.Img_ZH_CN;
    } 

    return imageSource;
  }
}
